<ok-card [loading]="state.loading()">
  <ok-expand-list
    [trackBy]="'identifier'"
    [sort]="state.currentSort()"
    [data]="state.priceRegulationsState().items"
    [configuration]="config()"
    (sortChange)="state.onSortChange($event)">
  </ok-expand-list>

  <mat-paginator
    #paginator
    class="paginator"
    [pageIndex]="state.filters().page.pageIndex"
    [pageSize]="state.filters().page.pageSize"
    [length]="state.priceRegulationsState().totalCount"
    [pageSizeOptions]="state.pageSizeOptions()"
    (page)="pageSwitch($event)"
    color="accent"
    [disabled]="state.loading()"></mat-paginator>
</ok-card>

<ng-template #headerRegulationTemplate>
  <div class="header-column-template">
    <span class="icon header-column-template__title">
      Regulering
      <span
        class="info-icon"
        matTooltip="Krone-værdien som afhængig af typen enten er en direkte rabat på total pris eller en fast regulering af tillæg"
        matTooltipPosition="below">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
      </span>
    </span>
    <span class="header-column-template__sub-title">Ekskl. moms</span>
  </div>
</ng-template>

<ng-template #headerLocationsTemplate>
  <div class="header-column-template">
    <span class="icon header-column-template__title">
      Lokationer
      <span class="info-icon" matTooltip="Antal lokationer hvor prisreguleringen er i brug" matTooltipPosition="below">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
      </span>
    </span>
  </div>
</ng-template>

<ng-template #rowTypeTemplate let-item>{{ item.type | translatePriceRegulationType }}</ng-template>

<ng-template #rowAffiliationTemplate let-item>
  @if (item.scopeType === PriceRegulationScopeType.Global) {
    Global
  } @else if (item.organizationId) {
    <a class="blue" [routerLink]="['/organizations']" [queryParams]="{ organizationId: item.organizationId }">
      {{ item.organizationName ?? '-' }}
    </a>
  } @else {
    -
  }
</ng-template>

<ng-template #rowRegulationTemplate let-item>
  @if (item.type === PriceRegulationType.Discount) {
    {{ item.discountAmountInKrWithoutVat | dkCurrency }}
  } @else {
    <div
      class="row-regulation"
      [matTooltip]="
        'Samlet tillæg: ' +
        ((item.okSupplementOverrideInKrWithoutVat ?? 0) + (item.organizationSupplementOverrideInKrWithoutVat ?? 0) | dkCurrency)
      "
      matTooltipPosition="below">
      @if (item.okSupplementOverrideInKrWithoutVat !== null && item.okSupplementOverrideInKrWithoutVat !== undefined) {
        <div>OK-tillæg: {{ item.okSupplementOverrideInKrWithoutVat | dkCurrency }}</div>
      }
      @if (item.organizationSupplementOverrideInKrWithoutVat !== null && item.organizationSupplementOverrideInKrWithoutVat !== undefined) {
        <div>Kundetillæg: {{ item.organizationSupplementOverrideInKrWithoutVat | dkCurrency }}</div>
      }
    </div>
  }
</ng-template>

<ng-template #rowLocationsTemplate let-item>
  <a
    class="blue"
    [routerLink]="['/locations']"
    [queryParams]="{ priceRegulationIdentifier: item.identifier, priceRegulationName: item.name }">
    {{ item.locationCount ?? 0 }}
  </a>
</ng-template>
